import React, { useState, useRef, useEffect } from 'react'

import { DownloadIcon, UploadIcon, LoadingIcon } from '@/components/icons'
import Modal from '@/components/Modal'

import FileInput from '@/components/Form/FileInput'

import Button from '@/components/Button'

import { formatDate } from '@/shared/util'

import {
  getClassSignInSheetUrl,
  getSessionCertificatesUrl,
  getRosterUrl,
} from '@/services/Reports'

import { getAllSessionDocuments, getDocumentUrl } from '@/services/Documents'

export default function SessionDocumentList({
  sessionId,
  formErrors,
  onUpload = () => {},
  updated = null,
  ...rest
}) {
  const [docs, setDocs] = useState([])
  const [loading, setLoading] = useState(false)

  const refs = {
    document: useRef(),
  }

  const context = { refs, formErrors }

  useEffect(() => {
    updated && setLoading(true)
    getAllSessionDocuments(sessionId).then(docs => {
      refs.document.current.value = ''
      setLoading(false)
      setDocs(docs)
    })
  }, [sessionId, updated])

  useEffect(() => {
    if (formErrors) setLoading(false)
  }, [formErrors])

  return (
    <Modal size="small" {...rest}>
      <h2>Reports</h2>
      <table className="downloads">
        <tbody>
          <tr>
            <td>Sign-in sheet</td>
            <td colSpan="2">
              <a
                onClick={() =>
                  window.open(getClassSignInSheetUrl(sessionId), '_blank')
                }
              >
                <span>Download</span> <DownloadIcon color="#1b3fea" />
              </a>
            </td>
          </tr>
          <tr>
            <td>Roster</td>
            <td colSpan="2">
              <a onClick={() => window.open(getRosterUrl(sessionId), '_blank')}>
                <span>Download</span> <DownloadIcon color="#1b3fea" />
              </a>
            </td>
          </tr>
          <tr>
            <td>Certificates (passing students only)</td>
            <td>
              <a
                onClick={() =>
                  window.open(
                    getSessionCertificatesUrl(sessionId, true),
                    '_blank',
                  )
                }
              >
                <span>Email</span> <DownloadIcon color="#1b3fea" />
              </a>
            </td>
            <td>
              <a
                onClick={() =>
                  window.open(
                    getSessionCertificatesUrl(sessionId, false),
                    '_blank',
                  )
                }
              >
                <span>Print</span> <DownloadIcon color="#1b3fea" />
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
      <h2>Upload new document</h2>
      <div className="row flex-start">
        <div className="col">
          <FileInput label="New Document" slug="document" context={context} />
        </div>
        <div className="col">
          <Button
            onClick={() => {
              setLoading(true)
              onUpload(refs.document.current.files[0])
            }}
            disabled={loading}
            text="Upload"
            className="blue"
          >
            <UploadIcon />
          </Button>
        </div>
        <div className="col">{loading && <LoadingIcon />}</div>
      </div>
      {formErrors && (
        <div className="row">
          <div className="col">
            {formErrors && <div className="error">{formErrors}</div>}
          </div>
        </div>
      )}
      <hr />
      <h2>Uploaded files</h2>
      <table className="downloads">
        <thead>
          <tr>
            <th>File name</th>
            <th>Date uploaded</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {docs.length ? (
            docs.map(doc => (
              <tr key={doc.fileName}>
                <td>{doc.fileName.slice(14).replace(/%20/g, ' ')}</td>
                <td>{formatDate(doc.dateUploaded, 'mm/dd/yyyy')}</td>
                <td>
                  <a
                    onClick={() =>
                      window.open(getDocumentUrl(doc.id), '_blank')
                    }
                  >
                    <span>Download</span> <DownloadIcon color="#1b3fea" />
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="center" colSpan="3">
                No documents
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Modal>
  )
}
